<div class="container">
  <div class="container-subscriptions">
    <div class="header">
        <h1 class="title">{{"SUBSCRIPTIONS" | translate}}</h1>
        <button class="btn btn-outline-primary primary-btn" (click)="setCreatingSubscription()">{{'NEW' | translate}}</button>
    </div>
    <div class="form-card">
        <div class="loading" *ngIf="loading">
            <div class="spinner-border" role="status"></div>
        </div>
          <table *ngIf="!loading" class="table table-bordered table-hover">
              <thead>
                <th scope="col" class="table-start">Id</th>
                <th scope="col">{{'NAME' | translate}}</th>
                <th scope="col">{{'EDIT' | translate}}</th>
                <th scope="col" class="table-end">{{'DELETE' | translate}}</th>
              </thead>
              <tbody>
                <tr *ngFor="let sub of clientSubscriptions">
                  <td>{{ sub.clientSubscriptionId }}</td>
                  <td>
                    {{ sub.clientSubscriptionName }}
                  </td>
                  <td>
                    <button class="btn btn-primary primary-btn" (click)="setEditingSubscription(sub.clientSubscriptionId)">
                      {{'EDIT' | translate}}
                    </button>
                  </td>
                  <td>
                    <button class="btn btn-primary remove-btn" (click)="modalDelete = true; subscriptionIdToDelete = sub.clientSubscriptionId">
                      {{'DELETE' | translate}}
                    </button>
                  </td>
                </tr>
              </tbody>
        </table>
    </div>
</div>

  <app-confirmation-modal *ngIf="modalDelete"
  [title]="'CONFIRM_DELETE_SUBSCRIPTION' | translate"
  [message]="'DELETE_SUBSCRIPTION_WARNING' | translate"
  [confirmText]="'DELETE' | translate"
  [cancelText]="'CANCEL' | translate"
  (response)="deteleSubscription($event)">
  > </app-confirmation-modal>

	<div class="modal delete-subscription-confirm-modal" id="deleteSubscriptionModal" tabindex="-1">
		<div class="modal-dialog subscription-modal-dialog" role="document">
			<div class="modal-content subscription-modal-content">
				<div class="modal-body subscription-modal-body">
					<h3 class="text-center">{{'SUCCESS' | translate}}</h3>
					<p class="text-center">{{ 'SUBSCRIPTION_DELETED_SUCCESS' | translate }}</p>
				</div>
				<div class="modal-buttons">
					<button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
				</div>
			</div>
		</div>
	</div>
</div>
